import React from 'react';
import { Criterion } from '../types';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface CriterionCardProps {
  criterion: Criterion;
  currentScore?: number;
  onScoreSelect: (score: number) => void;
}
export function CriterionCard({
  criterion,
  currentScore,
  onScoreSelect
}: CriterionCardProps) {
  return <div className="bg-white rounded-3xl p-6 md:p-8 apple-shadow border border-black/[0.02]" data-id="element-30">
      <h3 className="text-lg md:text-xl font-semibold text-[#1d1d1f] mb-6 leading-tight" data-id="element-31">
        {criterion.title}
      </h3>

      <div className="grid grid-cols-1 gap-3" data-id="element-32">
        {criterion.options.map(option => {
        const isSelected = currentScore === option.value;
        return <motion.button key={option.value} whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.99
        }} onClick={() => onScoreSelect(option.value)} className={`relative text-left w-full p-5 rounded-2xl border transition-all duration-200 ease-out flex items-start gap-4 ${isSelected ? 'border-[#0071e3] bg-[#0071e3]/[0.03] shadow-[0_0_0_1px_#0071e3]' : 'border-[#d2d2d7] hover:border-[#86868b] bg-white'}`} data-id="element-33">
              <div className="flex-shrink-0 mt-0.5" data-id="element-34">
                <div className={`w-6 h-6 rounded-full border flex items-center justify-center transition-colors ${isSelected ? 'border-[#0071e3] bg-[#0071e3]' : 'border-[#c6c6c8]'}`} data-id="element-35">
                  {isSelected && <CheckCircle2 className="w-4 h-4 text-white" data-id="element-36" />}
                </div>
              </div>

              <div data-id="element-37">
                <div className="flex items-center gap-2 mb-1" data-id="element-38">
                  <span className={`font-semibold text-[15px] ${isSelected ? 'text-[#0071e3]' : 'text-[#1d1d1f]'}`} data-id="element-39">
                    Skor {option.value}
                  </span>
                  <span className="text-[#86868b] text-sm font-medium" data-id="element-40">
                    — {option.label}
                  </span>
                </div>
                <p className={`text-[14px] leading-relaxed ${isSelected ? 'text-[#1d1d1f]' : 'text-[#1d1d1f]/70'}`} data-id="element-41">
                  {option.description}
                </p>
              </div>
            </motion.button>;
      })}
      </div>
    </div>;
}